import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { IconPreloaderService } from './services/icon-preloader.service';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet],
})
export class AppComponent {
  private iconPreloaderService = inject(IconPreloaderService);

  constructor() {
    document.title = `${environment.projectFullName} - Investment Specialist`;
    if (environment.theme) {
      document.body.classList.add(`${environment.theme}-theme`);
    }

    if (environment.isThemeLight) {
      document.body.classList.add(`_light`);
    }

    this.setFaviconByTheme();
    // Preload Icons
    this.iconPreloaderService
      .preloadIcons()
      .then(() => {
        console.log('All icons have been successfully preloaded.');
      })
      .catch((error) => {
        console.error('Error preloading icons:', error);
      });
  }

  private setFaviconByTheme(): void {
    const theme = environment.theme ?? 'wealth-online';
    const faviconPath =
      theme === 'otto1890' ? 'assets/ico/otto1890/favicon.ico' : 'assets/ico/wealth/favicon.ico';
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (link) {
      link.href = faviconPath;
    }
  }
}
